module.exports = __webpack_public_path__ + "img/FITNESS.2991c86e.svg";